import React from "react";

/**
 * Left sidebar + content panel (same pattern as Add-ons catalogue).
 * items: { key, label, badge?, group? } — group renders a section heading when it changes.
 */
export function AnalyticsSubsectionPanel({ activeKey, panelKey, children }) {
  if (activeKey !== panelKey) return null;
  return <div className="analytics-subsection-panel">{children}</div>;
}

export default function AnalyticsSubsectionLayout({
  items = [],
  activeKey,
  onSelect,
  children,
  sidebarTitle = "Sections",
  className = "",
}) {
  let lastGroup = null;
  const rootClass = ["analytics-subsection-layout", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass}>
      <aside className="analytics-subsection-sidebar" aria-label={sidebarTitle}>
        <p className="analytics-subsection-sidebar-title">{sidebarTitle}</p>
        <nav className="analytics-subsection-nav">
          {items.map((item) => {
            const showGroup = item.group && item.group !== lastGroup;
            if (item.group) lastGroup = item.group;
            const isActive = activeKey === item.key;
            return (
              <React.Fragment key={item.key}>
                {showGroup ? (
                  <p className="analytics-subsection-nav-group">{item.group}</p>
                ) : null}
                <button
                  type="button"
                  className={`analytics-subsection-nav-btn${isActive ? " analytics-subsection-nav-btn--active" : ""}`}
                  onClick={() => onSelect(item.key)}
                  aria-current={isActive ? "page" : undefined}
                >
                  <span className="analytics-subsection-nav-label">{item.label}</span>
                  {item.badge != null && item.badge !== "" ? (
                    <span className="analytics-subsection-nav-badge">{item.badge}</span>
                  ) : null}
                </button>
              </React.Fragment>
            );
          })}
        </nav>
      </aside>
      <main className="analytics-subsection-main">{children}</main>
    </div>
  );
}
